import { Tooltip } from '@mui/material';
import styled from 'styled-components';
import Button from '../../Button';
import { Flex } from '../../Flex';

const ActionButton = styled(Button)<{ $isActive: boolean }>`
  border-color: ${({ theme, $isActive }) =>
    $isActive ? theme.palette.border.strong : undefined} !important;
`;

const TruncatedText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

type Props = {
  actions: string[];
  selectedAction?: string;
  disabled?: boolean;
  onSelect: (action: string) => void;
};

const UserActionButtons = ({
  actions,
  selectedAction,
  disabled,
  onSelect,
}: Props) => (
  <Flex sx={{ gap: 1, flexWrap: 'wrap' }}>
    {actions.map((action) => (
      <Tooltip title={action} key={action}>
        <span>
          <ActionButton
            $isActive={selectedAction === action}
            variant="outlined"
            disabled={disabled}
            onClick={() => onSelect(action)}
          >
            <TruncatedText>{action}</TruncatedText>
          </ActionButton>
        </span>
      </Tooltip>
    ))}
  </Flex>
);

export default UserActionButtons;
